import React from 'react';
import { formDataShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  currentSelectedNetwork,
  getFormDataFieldDisplayValues,
  getFormDataFieldValue,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import {
  MOBILE,
  FIXED,
  IMPACT_LEVEL_1,
  IMPACT_LEVEL_2,
  IMPACT_LEVEL_3,
  IMPACT_LEVEL_4,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { CHANGE_QUESTIONS } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two';
import { impact } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/impact';
import { selectChangeSlaId } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two-constants';
import { getDateDisplay } from 'AppSrc/core/crq/crq-table-utils';

// return the impact level display string
const getImpactLevelDisplay = (formData) => {
  const value = getFormDataFieldValue({
    formData,
    sectionId: CHANGE_QUESTIONS,
    fieldId: impact.id,
  });
  const displayStrings = {
    [IMPACT_LEVEL_1]: '1',
    [IMPACT_LEVEL_2]: '2',
    [IMPACT_LEVEL_3]: '3',
    [IMPACT_LEVEL_4]: '4',
  };
  return displayStrings[value];
};


const getLevelDisplay = (network, formData) => {
  if (network === MOBILE) {
    const value = formData.riskValue;
    if (value === null || value === undefined) {
      console.warn('No risk value found in the form data');
      return 'No Risk level';
    }
    return `${value}`; // value is a label, such as "Risk level 1"
  }
  if (network === FIXED) {
    const impactLevel = getImpactLevelDisplay(formData);
    window.localStorage.setItem('impacts', impactLevel);
    if (!impactLevel) {
      // this is user entered data but it is a mandatory field,
      // so there should be a value
      console.warn('No impact level found in the form data');
      return 'No Impact level';
    }
    return `Impact level ${impactLevel}`;
  }
  console.warn(`Unrecognised network ${network}`);
  return '';
};

const ViewCrqMetadata = ({ formData }) => {
  const network = currentSelectedNetwork(formData);
  window.localStorage.setItem('networks', network);
  const levelDisplay = getLevelDisplay(network, formData);
  const dateCreated = getDateDisplay(formData.dateCreated);
  const slaValues = getFormDataFieldDisplayValues({
    formData,
    sectionId: CHANGE_QUESTIONS,
    fieldId: selectChangeSlaId,
  });
  const slaText = slaValues ? slaValues[0].text : '';
  return (
    <div className="view-crq-metadata">
      <div className="level-display">
        <p>{levelDisplay}</p>
      </div>
      <ul className="metadata">
        <li>
          <strong>Date created:</strong>
          <span>{dateCreated}</span>
        </li>
        <li>
          <strong>SLA type:</strong>
          <span>{slaText}</span>
        </li>
      </ul>
    </div>
  );
};

ViewCrqMetadata.propTypes = {
  formData: formDataShape,
};

export { ViewCrqMetadata, getImpactLevelDisplay };

